<template>
  <div class="debug-panel">
    <div @click="panelVisiable = !panelVisiable">
      Agora4, {{ connectionState }}
    </div>
    <div v-show="panelVisiable">
      <div>
        <!-- <button @click="join">join</button>
        <button @click="leave">leave</button>
        <br /> -->
        <label
          class="clickable"
          :class="{ 'success-color': webcamEnable }"
          @click="updateVauleToParent('webcamEnable', !webcamEnable)"
          >Video{{ showStatusText(webcamEnable) }}</label
        >
        <label
          class="clickable"
          :class="{ 'success-color': micEnabled }"
          @click="updateVauleToParent('micEnabled', !micEnabled)"
          >Audio{{ showStatusText(micEnabled) }}</label
        >
        <label
          class="clickable"
          :class="{ 'success-color': screenEnable }"
          @click="updateVauleToParent('screenEnable', !screenEnable)"
          >Screen{{ showStatusText(screenEnable) }}</label
        >
        <button @click="test">test</button>
      </div>
      <div>
        <label
          class="clickable"
          :class="{ 'success-color': wdWatch }"
          @click="updateVauleToParent('wdWatch', !wdWatch)"
          >WatchDog{{ showStatusText(wdWatch) }}</label
        >
        <label
          class="clickable"
          :class="{ 'success-color': subscribeMode }"
          @click="updateVauleToParent('subscribeMode', !subscribeMode)"
          >subscribeMode{{ showStatusText(subscribeMode) }}</label
        >
        <br />
        uid: {{ uid }} <br />received name:{{ receiveChannel }}<br />
        enterName: {{ wdenterChannelName }} <br />published:
        {{ rtc.published }}, spatial: {{ spatial }} <br />webcamOpening:
        {{ webcamOpening }} <br />micOpening: {{ micOpening }}
        <br />screenOpening: {{ screenOpening }}
        <div
          class="clickable"
          @click="videoEncoderVisiable = !videoEncoderVisiable"
        >
          videoEncoderConfig:
        </div>
        <div v-show="videoEncoderVisiable">
          width<input
            v-model.number="videoEncoderConfig.width"
            size="5"
          />,height<input v-model.number="videoEncoderConfig.height" size="5" />
          <br />frameMin<input size="5" value="not support" />,frameMax<input
            v-model.number="videoEncoderConfig.frameRate.max"
            size="5"
          />
          <br />bitrateMin<input
            v-model.number="videoEncoderConfig.bitrateMin"
            size="5"
          />,bitrateMax<input
            v-model.number="videoEncoderConfig.bitrateMax"
            size="5"
          />
        </div>
      </div>
      <div>
        <div class="clickable" @click="userListVisiable = !userListVisiable">
          user list: {{ this.rtc.remoteAudioTrack.length }}
        </div>
        <div v-show="userListVisiable">
          <div v-for="(item, index) in this.rtc.remoteAudioTrack" :key="index">
            userid: {{ item._userId }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  components: { EventBus },
  name: "Agora4",
  props: {
    hidePanel: { type: Boolean, default: false },
    cntStatus: { type: Object, default: {} },
    agoraEnable: { type: Boolean, default: false },
    wdWatch: { type: Boolean, default: false },
    uid: { type: Number, default: 1 },
    receiveChannel: { type: String, default: "a" },
    micVolume: { type: Number, default: 0.5 },
    voiceVolume: { type: Number, default: 0.8 },
    subscribeMode: { type: Boolean, default: true },
    spatial: { type: Boolean, default: true },
    screenEnable: { type: Boolean, default: false },
    webcamEnable: { type: Boolean, default: false },
    micEnabled: { type: Boolean, default: false },
    isResetConnect: { type: Boolean, default: false },
    isChrome: { type: Boolean, default: false },
    isFirefox: { type: Boolean, default: false },
  },
  data() {
    return {
      panelVisiable: false,

      connectionState: "DISCONNECTED",
      appId: "7b2529cb5e5a4abbb3b06cc2f277209f",
      rtc: {
        client: null,
        localAudioTrack: null,
        localScreenTrack: null,
        localWebcamTrack: null,
        remoteAudioTrack: [],
        published: false,
      },
      wdenterChannelName: "",
      wdCheckTime: 5000,
      watchdogFun: null,
      micOpening: false,
      screenOpening: false,
      webcamOpening: false,
      videoEncoderConfig: {
        bitrateMax: 5000,
        bitrateMin: 1000,
        width: 1920,
        height: 1080,
        frameRate: { max: 30 },
        // frameRate: 15,
      },
      lastVideoMode: "none",
      userListVisiable: true,
      subscribeMediaType: "audio",
      videoEncoderVisiable: false,
      inputDeviceId: "default",
      inputVideoDeviceId: "",

      sendAgoraAudioDataFun: null,
      remoteAudioVolume: [],
    };
  },
  computed: {
    videoMode: function () {
      if (this.screenEnable && this.webcamEnable) {
        return "screen";
      } else if (this.screenEnable && !this.webcamEnable) {
        return "screen";
      } else if (!this.screenEnable && this.webcamEnable) {
        return "webcam";
      } else {
        return "none";
      }
    },
  },
  watch: {
    async wdWatch(val) {
      if (!val) {
        await this.leaveChannel();
      }
    },
    async receiveChannel(val) {
      if (this.wdWatch) {
        console.log("receiveChannel change delay:" + val);
        clearInterval(this.watchdogFun);
        await this.leaveChannel();
        setTimeout(() => {
          console.log("receiveChannel setTimeout:" + val);
          this.watchdog();
          this.watchdogFun = setInterval(this.watchdog, this.wdCheckTime);
        }, 2000);
      }
    },
    async videoMode(val, lastVal) {
      this.lastVideoMode = lastVal;
      if (!this.wdWatch) {
        return;
      }

      if (this.connectionState == "CONNECTED") {
        await this.changeVideoTrack(val);
      } else if (this.connectionState == this.cntStatus.dcnted) {
        await this.joinChannel();
      }
    },
    async inputVideoDeviceId(val) {
      if (!this.wdWatch) {
        return;
      }

      if (
        this.connectionState == this.cntStatus.cnted &&
        this.videoMode == "webcam"
      ) {
        this.webcamOpening = true;
        await this.rtc.localWebcamTrack.setDevice(val);
        this.webcamOpening = false;
      }
    },
    async inputDeviceId(val) {
      if (!this.wdWatch) {
        return;
      }

      if (this.connectionState == this.cntStatus.cnted && this.micEnabled) {
        this.micOpening = true;
        await this.rtc.localAudioTrack.setDevice(val);
        this.micOpening = false;
      }
    },
    async micEnabled(val) {
      if (!this.wdWatch) {
        return;
      }

      if (this.connectionState == this.cntStatus.cnted) {
        if (this.rtc.localAudioTrack != null) {
          if (val) {
            await this.rtc.localAudioTrack.setMuted(!val);
          } else {
            if (this.videoMode == "none") {
              this.rtc.localAudioTrack.close();
              this.rtc.client.unpublish(this.rtc.localAudioTrack);
              this.rtc.localAudioTrack = null;
              this.rtc.published = false;
            } else {
              await this.rtc.localAudioTrack.setMuted(!val);
            }
          }
        } else {
          this.publishMic(this.inputDeviceId);
        }
      }
    },
    async micVolume(val) {},
    async voiceVolume(val) {
      for (let i = 0; i < this.rtc.remoteAudioTrack.length; i++) {
        console.log(
          this.rtc.remoteAudioTrack[i]._userId +
            "set voice vol: " +
            parseInt(val * 100)
        );
        this.rtc.remoteAudioTrack[i].setVolume(parseInt(val * 100));
      }
    },
    async isResetConnect(val) {
      if (val) {
        await this.leaveChannel();
        await this.joinChannel();
      }
    },
  },
  created() {
    //agora4 must be uncompress, make the file name same.
    // var agoraJs = document.createElement("script");
    // agoraJs.src = "/assets_v2/worldstream/js/AgoraRTC_N-production.js";
    // document.body.appendChild(agoraJs);
  },
  mounted() {
    this.receiveDeviceId();
    this.receiveVideoDeviceId();
    setTimeout(() => {
      this.agoraInit();
    }, 4000);

    if (!this.isChrome && this.inputDeviceId == "default") {
      this.inputDeviceId = "";
    }

    this.sendAgoraAudioDataFun = setInterval(
      this.sendAgoraAudioDataToFurioos,
      1000
    );

    // setInterval(() => {}, this.wdCheckTime);
  },
  methods: {
    async test() {
      console.log("test fun");
    },
    agoraInit() {
      this.rtc.client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
      this.rtc.client.on("user-published", async (user, mediaType) => {
        console.log("user-published, mediaType：", mediaType);
        if (mediaType == this.subscribeMediaType) {
          let remoteAudioTrack = await this.rtc.client.subscribe(
            user,
            this.subscribeMediaType
          );
          this.rtc.remoteAudioTrack.push(remoteAudioTrack);
          console.log("subscribe success");
          const remoteUserAudioTrack = user.audioTrack;
          remoteUserAudioTrack.play();
          console.log("play audio");
        }
      });

      this.rtc.client.on("user-unpublished", async (user, mediaType) => {
        console.log("user-published, mediaType：", mediaType);
        if (mediaType == this.subscribeMediaType) {
          for (let i = 0; i < this.rtc.remoteAudioTrack.length; i++) {
            if (this.rtc.remoteAudioTrack[i]._userId == user.uid) {
              this.rtc.remoteAudioTrack.splice(i, 1);
            }
          }
        }
      });

      this.rtc.client.on("connection-state-change", (evt) => {
        this.connectionState = evt;
        if (this.wdWatch) {
          if (this.connectionState == this.cntStatus.cnted) {
            this.$parent.showToast("Audio Service was connected!");
            setTimeout(() => {
              this.$parent.closeToast();
            }, 1000);
          } else {
            this.$parent.showToast(
              "Audio Service was disconnected. Reconnecting..."
            );
          }
        }
        console.log("connection-state-change: ", evt);
      });

      this.watchdogFun = setInterval(this.watchdog, this.wdCheckTime);
    },
    async join() {
      await this.joinChannel();
    },
    async leave() {
      await this.leaveChannel();
    },
    async watchdog() {
      if (this.wdWatch) {
        if (this.isResetConnect) {
          console.log("WD: isresetconnect");
          return;
        }

        // check mic name, micVolume and voiceVolume
        if (this.connectionState == this.cntStatus.cnted) {
          if (this.micEnabled) {
            if (this.rtc.localAudioTrack != null) {
              if (
                this.inputDeviceId !=
                this.rtc.localAudioTrack._config.microphoneId
              ) {
                if (!this.micOpening) {
                  this.micOpening = true;
                  await this.rtc.localAudioTrack.setDevice(this.inputDeviceId);
                  this.micOpening = false;
                }
              } else {
                await this.rtc.localAudioTrack.setMuted(false);
              }
            } else {
              if (!this.micOpening) {
                this.publishMic(this.inputDeviceId);
              }
            }
          } else {
            if (this.rtc.localAudioTrack != null) {
              await this.rtc.localAudioTrack.setMuted(true);
            }
          }
          for (let i = 0; i < this.rtc.remoteAudioTrack.length; i++) {
            this.rtc.remoteAudioTrack[i].setVolume(
              parseInt(this.voiceVolume * 100)
            );
          }
        }

        // //for video
        if (this.connectionState == this.cntStatus.cnted) {
          //chrome screen label: sreenshare:screen, program:window, tab:web-contents-media-stream
          if (this.videoMode == "screen") {
            if (this.isChrome) {
              if (this.screenOpening) {
                console.log("screen is opening");
              } else {
                if (this.rtc.localScreenTrack == null) {
                  await this.changeVideoTrack("screen");
                } else {
                  let videoTrack;
                  if (Array.isArray(this.rtc.localScreenTrack)) {
                    for (
                      let index = 0;
                      index < this.rtc.localScreenTrack.length;
                      index++
                    ) {
                      if (
                        this.rtc.localScreenTrack[index].trackMediaType ==
                        "video"
                      ) {
                        videoTrack =
                          this.rtc.localScreenTrack[
                            index
                          ].getMediaStreamTrack();
                      }
                    }
                  } else {
                    videoTrack =
                      this.rtc.localScreenTrack.getMediaStreamTrack();
                  }
                  console.log(videoTrack);
                  if (
                    videoTrack.label.indexOf("screen") < 0 &&
                    videoTrack.label.indexOf("web-contents-media-stream") < 0 &&
                    videoTrack.label.indexOf("window") < 0
                  ) {
                    // await this.changeVideoTrack("screen");
                  }
                }
              }
            }
          } else if (this.videoMode == "webcam") {
            if (this.webcamOpening) {
              console.log("webcam is opening");
            } else {
              if (this.rtc.localScreenTrack != null) {
                if (Array.isArray(this.rtc.localScreenTrack)) {
                  for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
                    this.rtc.localScreenTrack[i].close();
                  }
                } else {
                  this.rtc.localScreenTrack.close();
                }
                this.rtc.client.unpublish(this.rtc.localScreenTrack);
                this.rtc.localScreenTrack = null;
              }
              if (this.rtc.localWebcamTrack == null) {
                await this.changeVideoTrack("webcam");
              } else {
                if (
                  this.rtc.localWebcamTrack._config.cameraId !=
                  this.inputVideoDeviceId
                ) {
                  this.webcamOpening = true;
                  await this.rtc.localWebcamTrack.setDevice(
                    this.inputVideoDeviceId
                  );
                  this.webcamOpening = false;
                }
              }
            }
          } else if (this.videoMode == "none") {
            if (
              this.rtc.localScreenTrack != null ||
              this.rtc.localWebcamTrack != null
            ) {
              await this.changeVideoTrack("none");
            }
          }
        }

        if (
          (this.connectionState == this.cntStatus.cnting ||
            this.connectionState == this.cntStatus.cnted) &&
          this.wdenterChannelName == this.receiveChannel
        ) {
          console.log(
            "WD:status is " +
              this.connectionState +
              " and checking name is ==,return"
          );
          return;
        }
        if (this.wdenterChannelName != this.receiveChannel) {
          console.warn(
            "WD:check channel error," +
              this.receiveChannel +
              " ? " +
              this.wdenterChannelName
          );
          if (this.connectionState == this.cntStatus.cnted) {
            await this.leaveChannel();
            await this.joinChannel();
          } else if (this.connectionState == this.cntStatus.dcnted) {
            await this.joinChannel();
          }
        } else if (
          this.wdenterChannelName == this.receiveChannel &&
          this.wdenterChannelName != ""
        ) {
          if (this.connectionState == this.cntStatus.dcnted) {
            console.warn("WD:same channel, join when disconnected");
            await this.joinChannel();
          }
        }
      } else {
        if (this.connectionState == this.cntStatus.cnted) {
          await this.leaveChannel();
        }
        this.wdenterChannelName = "";
      }
    },
    async joinChannel() {
      try {
        console.log(this.receiveChannel);
        console.log(this.uid);
        let uid = await this.rtc.client.join(
          this.appId,
          this.receiveChannel,
          null,
          this.uid
        );
        this.wdenterChannelName = this.rtc.client.channelName;
        console.log("await join: ", this.rtc.client.channelName);
        if (this.micEnabled || this.videoMode != "none") {
          await this.publishLocalStream(this.micEnabled, this.videoMode);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async leaveChannel() {
      this.unpublishLocalStream();
      await this.rtc.client.leave();
      this.rtc.remoteAudioTrack = [];
    },
    async publishLocalStream(micEnabled = false, videoMode = "none") {
      console.log(micEnabled);
      console.log(videoMode);
      if (!micEnabled && videoMode == "none") {
        return;
      }
      console.log("funpublishLocalStream");
      let localStream = [];
      if (micEnabled) {
        try {
          this.rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
            microphoneId: this.inputDeviceId,
          });
          this.$store.commit("updateMicPermission");
          console.log(parseInt(this.micVolume * 100));
          this.rtc.localAudioTrack.on("track-ended", () => {
            this.$parent.sendFurioosMsg({
              sinewave: "microphone",
              enabled: false,
              service: "agora",
            });
          });
          localStream.push(this.rtc.localAudioTrack);
        } catch (error) {
          console.error("get audio error: ", error);
          if (error.code == "PERMISSION_DENIED") {
            this.$parent.showToast(
              "Microphone: You did not grant access so other cannot hear you. Please allow the page to access your microphone first."
            );
          } else {
            this.$parent.showToast(error.message);
          }
          this.updateVauleToParent("micEnabled", false);
          this.$parent.sendFurioosMsg({
            sinewave: "microphone",
            enabled: false,
            service: "agora",
          });
          return;
        }
      }
      if (videoMode == "screen") {
        try {
          this.screenOpening = true;
          this.rtc.localScreenTrack = await AgoraRTC.createScreenVideoTrack(
            { encoderConfig: this.videoEncoderConfig },
            "auto"
          );
          this.screenOpening = false;
          if (Array.isArray(this.rtc.localScreenTrack)) {
            for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
              localStream.push(this.rtc.localScreenTrack[i]);
              if (this.rtc.localScreenTrack[i].trackMediaType == "video") {
                this.rtc.localScreenTrack[i].on("track-ended", () => {
                  this.$parent.sendFurioosMsg({
                    sinewave: "screen sharing",
                    enabled: false,
                  });
                });
              }
            }
          } else {
            localStream.push(this.rtc.localScreenTrack);
            this.rtc.localScreenTrack.on("track-ended", () => {
              this.$parent.sendFurioosMsg({
                sinewave: "screen sharing",
                enabled: false,
              });
            });
          }
        } catch (error) {
          console.error("get screen error: ", error);
          this.screenOpening = false;
          if (error.code == "PERMISSION_DENIED") {
            this.$parent.showToast(
              "Screen Share: Screen sharing is currently disabled. If you want to share your screen with other users, please grant permission."
            );
          } else {
            this.$parent.showToast(error.message);
          }
          this.updateVauleToParent("screenEnable", false);
          this.$parent.sendFurioosMsg({
            sinewave: "screen sharing",
            enabled: false,
          });
          return;
        }
      } else if (videoMode == "webcam") {
        try {
          this.webcamOpening = true;
          this.rtc.localWebcamTrack = await AgoraRTC.createCameraVideoTrack({
            cameraId: this.inputVideoDeviceId,
            encoderConfig: this.videoEncoderConfig,
          });
          this.$store.commit("updateCamPermission");
          this.webcamOpening = false;
          this.rtc.localWebcamTrack.on("track-ended", () => {
            this.$parent.sendFurioosMsg({
              sinewave: "webcam",
              enabled: false,
            });
          });
          localStream.push(this.rtc.localWebcamTrack);
        } catch (error) {
          console.error("get webcam error: ", error);
          this.updateVauleToParent("webcamEnable", false);
          if (error.code == "PERMISSION_DENIED") {
            this.$parent.showToast(
              "Webcam: You did not grant access so other cannot hear you. Please allow the page to access your webcam first."
            );
          } else if (error.code == "DEVICE_NOT_FOUND") {
            this.$parent.showToast("Webcam: Requested device not found.");
          } else {
            this.$parent.showToast(error.message);
          }
          this.$parent.sendFurioosMsg({
            sinewave: "webcam",
            enabled: false,
          });
          return;
        }
      }
      await this.rtc.client.setClientRole("host");
      await this.rtc.client.publish(localStream);
      this.rtc.published = true;
    },
    unpublishLocalStream() {
      if (this.rtc.localAudioTrack != null) {
        this.rtc.localAudioTrack.close();
        this.rtc.localAudioTrack = null;
      }
      if (this.rtc.localScreenTrack != null) {
        if (Array.isArray(this.rtc.localScreenTrack)) {
          for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
            this.rtc.localScreenTrack[i].close();
          }
        } else {
          this.rtc.localScreenTrack.close();
        }
        this.rtc.localScreenTrack == null;
      }
      if (this.rtc.localWebcamTrack != null) {
        this.rtc.localWebcamTrack.close();
        this.rtc.localWebcamTrack = null;
      }
      this.rtc.client.unpublish();
      this.rtc.published = false;
    },
    async changeVideoTrack(videoMode = "none") {
      console.log("changeVideoTrack: ", videoMode);
      if (videoMode == "screen") {
        try {
          if (this.rtc.localWebcamTrack != null) {
            this.rtc.localWebcamTrack.close();
            this.rtc.client.unpublish(this.rtc.localWebcamTrack);
            this.rtc.localWebcamTrack = null;
          }

          this.screenOpening = true;
          this.rtc.localScreenTrack = await AgoraRTC.createScreenVideoTrack(
            { encoderConfig: this.videoEncoderConfig },
            "auto"
          );
          let localStream = [];
          this.screenOpening = false;
          if (Array.isArray(this.rtc.localScreenTrack)) {
            for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
              localStream.push(this.rtc.localScreenTrack[i]);
              if (this.rtc.localScreenTrack[i].trackMediaType == "video") {
                this.rtc.localScreenTrack[i].on("track-ended", () => {
                  this.$parent.sendFurioosMsg({
                    sinewave: "screen sharing",
                    enabled: false,
                  });
                });
              }
            }
          } else {
            localStream.push(this.rtc.localScreenTrack);
            this.rtc.localScreenTrack.on("track-ended", () => {
              this.$parent.sendFurioosMsg({
                sinewave: "screen sharing",
                enabled: false,
              });
            });
          }
          await this.rtc.client.setClientRole("host");
          this.rtc.client.publish(localStream);
          this.rtc.published = true;
        } catch (error) {
          console.error("get screen error: ", error);
          if (this.lastVideoMode == "none") {
            this.updateVauleToParent("webcamEnable", false);
          }
          if (error.code == "PERMISSION_DENIED") {
            this.$parent.showToast(
              "Screen Share: Screen sharing is currently disabled. If you want to share your screen with other users, please grant permission."
            );
          } else {
            this.$parent.showToast(error.message);
          }
          this.screenOpening = false;
          this.updateVauleToParent("screenEnable", false);
          this.$parent.sendFurioosMsg({
            sinewave: "screen sharing",
            enabled: false,
          });
          return;
        }
      } else if (videoMode == "webcam") {
        try {
          if (this.rtc.localScreenTrack != null) {
            if (Array.isArray(this.rtc.localScreenTrack)) {
              for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
                this.rtc.localScreenTrack[i].close();
              }
            } else {
              this.rtc.localScreenTrack.close();
            }
            this.rtc.client.unpublish(this.rtc.localScreenTrack);
            this.rtc.localScreenTrack = null;
          }

          this.webcamOpening = true;
          this.rtc.localWebcamTrack = await AgoraRTC.createCameraVideoTrack({
            cameraId: this.inputVideoDeviceId,
            encoderConfig: this.videoEncoderConfig,
          });

          this.$store.commit("updateCamPermission");
          this.webcamOpening = false;
          this.rtc.localWebcamTrack.on("track-ended", () => {
            this.$parent.sendFurioosMsg({
              sinewave: "webcam",
              enabled: false,
            });
          });
          await this.rtc.client.setClientRole("host");
          this.rtc.client.publish(this.rtc.localWebcamTrack);
          this.rtc.published = true;
        } catch (error) {
          console.error("get webcam error: ", error);
          if (error.code == "PERMISSION_DENIED") {
            this.$parent.showToast(
              "Webcam: You did not grant access so other cannot hear you. Please allow the page to access your webcam first."
            );
          } else if (error.code == "DEVICE_NOT_FOUND") {
            this.$parent.showToast("Webcam: Requested device not found.");
          } else {
            this.$parent.showToast(error.message);
          }
          this.updateVauleToParent("webcamEnable", false);
          this.$parent.sendFurioosMsg({
            sinewave: "webcam",
            enabled: false,
          });
          return;
        }
      } else {
        if (this.rtc.localWebcamTrack != null) {
          this.rtc.localWebcamTrack.close();
          this.rtc.client.unpublish(this.rtc.localWebcamTrack);
          this.rtc.localWebcamTrack = null;
        }

        if (this.rtc.localScreenTrack != null) {
          if (Array.isArray(this.rtc.localScreenTrack)) {
            for (let i = 0; i < this.rtc.localScreenTrack.length; i++) {
              this.rtc.localScreenTrack[i].close();
            }
          } else {
            this.rtc.localScreenTrack.close();
          }
          this.rtc.client.unpublish(this.rtc.localScreenTrack);
          this.rtc.localScreenTrack = null;
        }

        if (!this.micEnabled && this.rtc.localAudioTrack != null) {
          this.unpublishMic();
          this.rtc.published = false;
        } else if (this.rtc.localAudioTrack == null) {
          this.rtc.published = false;
        }
      }
    },
    async publishMic(deviceId) {
      try {
        this.micOpening = true;
        this.rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
          microphoneId: deviceId,
        });

        this.$store.commit("updateMicPermission");
        this.micOpening = false;

        this.rtc.localAudioTrack.on("track-ended", () => {
          this.$parent.sendFurioosMsg({
            sinewave: "microphone",
            enabled: false,
            service: "agora",
          });
        });
        await this.rtc.client.setClientRole("host");
        this.rtc.client.publish(this.rtc.localAudioTrack);
        this.rtc.published = true;
      } catch (error) {
        console.error("get audio error: ", error);
        if (error.code == "PERMISSION_DENIED") {
          this.$parent.showToast(
            "Microphone: You did not grant access so other cannot hear you. Please allow the page to access your microphone first."
          );
        } else {
          this.$parent.showToast(error.message);
        }
        this.updateVauleToParent("micEnabled", false);
        this.$parent.sendFurioosMsg({
          sinewave: "microphone",
          enabled: false,
          service: "agora",
        });
        this.micOpening = false;
        return;
      }
    },
    async unpublishMic() {
      if (this.rtc.localAudioTrack != null) {
        this.rtc.localAudioTrack.close();
        this.rtc.client.unpublish(this.rtc.localAudioTrack);
        this.rtc.localAudioTrack = null;
      }
    },
    async setMic(val) {},
    sendAgoraAudioDataToFurioos() {
      if (this.connectionState == this.cntStatus.cnted) {
        this.remoteAudioVolume = [];
        let volume = 0;
        for (let i = 0; i < this.rtc.remoteAudioTrack.length; i++) {
          volume = this.rtc.remoteAudioTrack[i].getVolumeLevel();
          if (volume < 0.01) {
            continue;
          }
          this.remoteAudioVolume.push({
            ProvidedUserID: this.rtc.remoteAudioTrack[i].getUserId(),
            VolumeDecibels: volume,
          });
        }
        if (this.connectionState == this.cntStatus.cnted && this.micEnabled) {
          volume = this.rtc.localAudioTrack.getVolumeLevel();
          if (volume >= 0.01) {
            this.remoteAudioVolume.push({
              ProvidedUserID: this.uid,
              VolumeDecibels: volume,
            });
          }
        }
        if (this.remoteAudioVolume.length > 0) {
          this.$parent.sendRemoteAudioData(this.remoteAudioVolume);
          this.remoteAudioVolume = [];
        }
      }
    },
    receiveDeviceId() {
      EventBus.$on("updateInputDeviceId", (deviceId) => {
        this.inputDeviceId = deviceId;
      });
    },
    receiveVideoDeviceId() {
      EventBus.$on("updateVideoInputDeviceId", (deviceId) => {
        this.inputVideoDeviceId = deviceId;
      });
    },
    updateVauleToParent(key, value) {
      this.$emit("update:" + key, value);
    },
    showStatusText(val) {
      return val ? "√" : "×";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Agora4.vue